export default {
  LAND_LINE: 1,
  TOLL_FREE: 2,
  HOSTED_NUMBER: 3
};

